export const rewardsPercentage = [
    {
        shortCode: 200,
        percentage: 5
    },
    {
        shortCode: 210,
        percentage: 2
    },
    {
        shortCode: 300,
        percentage: 5
    }, {
        shortCode: 310,
        percentage: 3
    },
    {
        shortCode: 400,
        percentage: 10
    },
    {
        shortCode: 410,
        percentage: 4
    },
    {
        shortCode: 500,
        percentage: 15
    },
    {
        shortCode: 510,
        percentage: 6
    },
    {
        shortCode: 600,
        percentage: 30
    }, {
        shortCode: 610,
        percentage: 9
    },
]

export const roundToNearestMultipleOfTen = (value) => {
    const lastDigit = value % 10000; // Obtiene el último dígito (unidad de mil).
    if (lastDigit >= 6000) {
        // Si está entre 6 y 9, redondea hacia arriba.
        return Math.ceil(value / 10000) * 10000;
    } else {
        // Si está entre 1 y 5, redondea hacia abajo.
        return Math.floor(value / 10000) * 10000;
    }
}